export const SELECCION = "S";
